/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Packaging_Log_Output_Not_FoundInputs */

const vi_error_packaging_log_output_not_found = /** @type {(inputs: Error_Packaging_Log_Output_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy dòng sản phẩm này trong sổ, có thể mẻ vừa bị sửa. Tải lại sổ rồi bấm in lại.`)
};

/**

* @param {Error_Packaging_Log_Output_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_packaging_log_output_not_found = /** @type {((inputs?: Error_Packaging_Log_Output_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packaging_Log_Output_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_packaging_log_output_not_found(inputs)
});